import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/*##################################################################################* 
 * PIPE SPRO : sproNoSanitize
 * 
 * DESCRIPTION : Permet d'envoyer du code HTML dans une variable sans que le navigateur
 * ne modifie la chaine.
 * 
 *
 ##################################################################################*/

@Pipe({ name: 'sproNoSanitize', pure: false })
export class noSanitize implements PipeTransform {
  constructor(public sanitizer: DomSanitizer) {
  }

  transform(content) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}


// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/pipes/spro-pipe-noSanitize/noSanitize.pipe.ts